export default "__VITE_ASSET__CH93j4F8__"